import { TFunction, useTranslation } from 'react-i18next';

import { useAutomationsSelector } from '../../../store/react';

import { getMovingBranchType } from '../../../store/selectors';
import {
  MovingBranchOptions,
  type MovingBranchType,
} from 'pages/AutomationEngine/constants';

import { Placeholder } from './PlaceHolder';

const getPlaceHolderText = (
  movingBranchType: MovingBranchType,
  t: TFunction
) => {
  switch (movingBranchType) {
    case MovingBranchOptions.MergedBranch:
      return t('Drop a merged branch anywhere but inside itself.');

    case MovingBranchOptions.UnmergedBranch:
      return t("Drop an unmerged branch only at another branch's end.");

    default: // MovingBranchOptions.GoalCondition
      return t('Child steps will have movement options upon parent placement.');
  }
};

const MovingPlaceholder = (props: any) => {
  const { t } = useTranslation();

  const movingBranchType = useAutomationsSelector(getMovingBranchType);

  return (
    <Placeholder
      placeholderText={getPlaceHolderText(movingBranchType, t)}
      {...props}
    />
  );
};

export default MovingPlaceholder;
